module.exports = __webpack_public_path__ + "static/media/trust.3ca32cdf.png";